import React from 'react';
import { __ } from '../../Lang.js';

const GuestFooter = () => {
  return (
    <section className="cta-footer">
      <div className="cta-footer__content">
        <h2 className="cta-footer__title">{__('That Which Is')}</h2>
        <p className="cta-footer__subtitle">{__('Teachings of the Spiritual Heart')}</p>
        <a
          href="/app/students/login?previous_url=/media/videos/account/"
          className="cta-footer__button"
        >
          {__('Subscribe Now')}
        </a>
      </div>
      <div className="cta-footer__background">
        <img
          src="https://now.cdn.msia.org/3259/TWI/twi_footer_bg.jpg"
          alt={__('TWI Founders')}
        />
      </div>
    </section>
  );
};

export default GuestFooter;